import { Moment } from "moment-timezone";
import ResponsiveScheduleCalendarDatesHeader from "./ResponsiveScheduleCalendarDatesHeader";
import ScheduleCalendarVerticalGrid from "./ScheduleCalendarVerticalGrid";
import ScheduleCalendarHorizontalGrid from "./ScheduleCalendarHorizontalGrid";
import CalendarScheduleModel from "../../models/CalendarScheduleModel";
import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";
import ScheduleSlotWeekContainer from "./ScheduleSlotWeekContainer";
import moment from "moment";
import LoadingSpinner from "../LoadingSpinner";
import { classNames } from "../../helpers";

type ScheduleCalendarProps = {
  selectedDate: Moment;
  viewingDate: Moment;
  isLoading?: boolean;
  schedule?: CalendarScheduleModel | null;
  compact?: boolean;
  showDates?: boolean;
  onChangeViewingDate: (date: Moment) => void;
  onSlotClick?: (slot: CalendarScheduleSlotModel) => void;
  highlightSelectedDate?: boolean;
  proposedSchedule?: boolean;
  cancel?: boolean;
};

export default function ScheduleCalendar(props: ScheduleCalendarProps) {
  const {
    selectedDate,
    compact = false,
    highlightSelectedDate = true,
    isLoading = false,
    proposedSchedule,
    cancel,
  } = props;

  return (
    <div className="flex  relative flex-auto flex-col  bg-white min-h-[20rem]">
      <div
        style={{ width: !!proposedSchedule ? "" : "165%" }}
        className="flex max-w-full flex-none flex-col relative sm:max-w-none md:max-w-full"
      >
        {!!isLoading && (
          <div
            className={classNames(
              "h-full  absolute top-0 left-0 bg-white/80 flex justify-center items-center z-50",
              !!proposedSchedule ? "w-full" : "w-screen"
            )}
          >
            <div></div>
            <LoadingSpinner size={50} />
          </div>
        )}
        <div className="sticky  top-0  z-[2] flex-none bg-white shadow ring-1 ring-black ring-opacity-5 sm:ltr:pr-8 sm:rtl:pl-8">
          <ResponsiveScheduleCalendarDatesHeader {...props} />
        </div>
        <div className="flex flex-auto">
          <div className="sticky ltr:left-0 rtl:right-0 z-0 w-14 flex-none bg-white ring-1 ring-gray-100" />
          <div
            className="grid flex-auto grid-cols-1 grid-rows-1"
            data-cy="calenderTable"
          >
            {/* Horizontal lines */}
            <ScheduleCalendarHorizontalGrid
              step={1}
              rowHeight={compact ? "1.2rem" : "3.5rem"}
            />

            {/* Vertical lines */}
            <ScheduleCalendarVerticalGrid
              selectedDate={selectedDate}
              highlightSelectedDate={highlightSelectedDate}
            />

            {/* Events */}
            <ol
              className="col-start-1 col-end-2 row-start-1  grid grid-cols-1 sm:grid-cols-7 sm:ltr:pr-8 sm:rtl:pl-8"
              style={{
                gridTemplateRows: "1.75rem repeat(24, minmax(0, 1fr)) auto",
              }}
            >
              <ScheduleSlotWeekContainer {...props} />
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}
